/* tslint:disable */

export class DecisionServiceVersionListDataItem {
		Id: number;
		Order: number;
		Value: string;
		Name: string;

}



// WEBPACK FOOTER //
// D:/a/1/s/src/services/generated/models/DecisionServiceVersionListDataItem.ts